<template>
    <el-card v-loading="loading">
        <div class="reception-member-appoint flex">
            <el-input
                @keyup.enter.native="searchAppoint('')"
                class="reception-nickname"
                v-model="form.keyword"
                :placeholder="$t('Reception.Second.search_placeholder')">
            </el-input>
            <div class="pl-2">
                <el-button
                    @click="searchAppoint('')"
                    type="primary"
                >{{ $t('Common.search') }}</el-button>
            </div>
        </div>
        <div class="label">{{ $t('Reception.Second.linshi') }}</div>
        <div class="flex">
            <el-table
                :data="visitorData"
                style="width: 100%;margin: 15px 0;"
                border>
                <el-table-column prop="protectDays" :label="$t('Reception.Second.day')" ></el-table-column>
                <el-table-column prop="clientName" :label="$t('Common.name')">
                    <template slot-scope="{row}">
                        <div
                            @click="handleUser(row.clientId)"
                            class="fitness-blue cursor-pointer">
                            {{ row.clientName }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="clientGender"
                    :label="$t('Common.gender')"
                ></el-table-column>
                <el-table-column
                    prop="clientPhone"
                    :label="$t('Common.phone_number')"
                ></el-table-column>
                <el-table-column
                    prop="clientType"
                    :label="$t('Common.number_type')"
                ></el-table-column>
                <el-table-column
                    prop="salesNickname"
                    :label="$t('Common.saler')"
                ></el-table-column>
                <el-table-column
                    prop="allocateDate"
                    :label="$t('Common.fen_tiem')"
                ></el-table-column>
                <el-table-column
                    prop="lastFollowDate"
                    :label="$t('Common.last_follow_time')"
                ></el-table-column>
                <el-table-column
                    prop="lastFollowNickname"
                    :label="$t('Common.last_follow_people')"
                ></el-table-column>
            </el-table>
            <div class="member-receptionist flex justify-center flex-column">
                <div class="flex items-center">
                    <span class="label">{{ $t('Reception.Second.jie_people') }}：</span>
                    <el-select
                        @change="temporaryText = null"
                        class="pr-2"
                        v-model="form.temporaryStaffId"
                        :placeholder="$t('Reception.Second.jie_people_placeholder')">
                        <input class="search-sale" type="text" v-model="temporaryText">
                        <el-option
                            v-for="(item, index) in filterTemporaryList"
                            :key="`temporary${index}`"
                            :label="item.nickname"
                            :value="item.id"
                            :disabled="item.id === 'no'">
                        </el-option>
                    </el-select>
                </div>
                <el-button
                    class="handle-temporary-btn"
                    @click="handleTemporary"
                    type="primary">
                    {{ $t('Reception.Second.linshi_appoint') }}
                </el-button>
            </div>
        </div>
        <div
            class="label"
            style="margin: 26px 0 18px;"
        >{{ $t('Reception.Second.appoint_search') }}</div>
        <form
            @submit.prevent="fetchData"
            class="pb-6 flex justify-between reservation-inquiry">
            <div class="flex">
                <el-select
                    class="pr-2"
                    @change="appointText = null"
                    v-model="form.salesStaffId"
                    :placeholder="$t('Reception.Second.jie_people_placeholder')">
                    <input
                        class="search-sale"
                        type="text"
                        v-model="appointText">
                    <el-option
                        v-for="(item, index) in filterAppointList"
                        :key="`appoint${index}`"
                        :label="item.nickname"
                        :value="item.id"
                        :disabled="item.id == 'no'">
                    </el-option>
                </el-select>
                <el-select
                    class="pr-2"
                    v-model="form.status"
                    :placeholder="$t('Reception.Second.appoint_status')">
                    <el-option
                        v-for="(item, index) in status"
                        :key="`${index}-${item.code}`"
                        :label="item.name"
                        :value="item.code">
                    </el-option>
                </el-select>
                <el-date-picker
                    v-model="form.date"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$t('Common.choose_date')">
                </el-date-picker>
                <div class="ml-2">
                    <el-button type="primary" @click="fetchData">
                        {{ $t('Common.search_cha') }}
                    </el-button>
                </div>
            </div>
        </form>
        <el-table
            class="visit-registra-table"
            ref="singleTable"
            highlight-current-row
            :data="appointmentData"
            @current-change="handleCurrentChange"
            border>
            <el-table-column
                fixed
                prop="salesStaffNickname"
                :label="$t('Reception.Second.appoint_saler')" />
            <el-table-column prop="protectDays" :label="$t('Reception.Second.day')" />
            <el-table-column prop="clientName" :label="$t('Common.name')">
                <template slot-scope="{row}">
                    <div
                        @click="handleUser(row.clientId)"
                        class="fitness-blue cursor-pointer">
                        {{ row.clientName }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="clientGender" :label="$t('Common.gender')" width="55px" />
            <el-table-column prop="clientPhone" :label="$t('Common.phone_number')" />
            <el-table-column prop="clientType" :label="$t('Common.number_type')" />
            <el-table-column prop="appointedAt" :label="$t('Reception.Second.appoint_time')" />
            <el-table-column prop="teamLessonName" :label="$t('Reception.Second.appoint_lesson')" />
            <el-table-column prop="receivedAt" :label="$t('Reception.Second.jie_time')" />
            <el-table-column prop="receiveStaffNickname" :label="$t('Reception.Second.jie_saler')" />
            <el-table-column prop="leftAt" :label="$t('Common.leave_time')"/>
        </el-table>
        <div class="receptionist-handle mt-8 flex items-center">
            <div class="flex items-center">
                <span class="label">{{ $t('Common.store_tip') }}：</span>
                <el-select
                    class="pr-2"
                    v-model="form.storeId"
                    :placeholder="$t('Common.store_placeholder')">
                    <el-option
                        v-for="(item, index) in stores"
                        :key="`${index}-${item.id}`"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </div>
            <div class="flex items-center ml-10">
                <span class="label">{{ $t('Reception.Second.jie_people') }}：</span>
                <el-select
                    @change="confirmText = null"
                    class="pr-2"
                    v-model="form.receiveStaffId"
                    :placeholder="$t('Reception.Second.jie_people_placeholder')">
                    <input class="search-sale" type="text" v-model="confirmText">
                    <el-option
                        v-for="(item, index) in filterConfirmList"
                        :key="`confirm${index}`"
                        :label="item.nickname"
                        :value="item.id"
                        :disabled="item.id == 'no'">
                    </el-option>
                </el-select>
            </div>
            <div class="ml-8">
                <el-button
                    type="primary"
                    @click="handleAppoint"
                >{{ $t('Board.Appointment.title') }}</el-button>
            </div>
            <div class="ml-8">
                <el-button type="success" @click="handleLeave">
                    {{ $t('Reception.Second.client_out') }}
                </el-button>
            </div>
            <div class="ml-8">
                <el-button @click="handleCancel">
                    {{ $t('Reception.Second.cancel_appoint') }}
                </el-button>
            </div>
        </div>
        <!-- 新建客户弹窗 -->
        <new-customer ref="newCustomer" @searchAppoint="searchAppoint" />
    </el-card>
</template>

<script>
import filterRole from '@/mixins/filterRole.js';
import handleUser from '@/mixins/handleUser.js';
import { DatePicker } from 'element-ui';
import NewCustomer from '@/components/Dialog/NewCustomer';

export default {
    name: 'VisitRegistration',
    components: {
        ElDatePicker: DatePicker,
        NewCustomer,
    },
    mixins: [filterRole, handleUser],
    data() {
        return {
            form: {
                keyword: '',
                // 预约查询
                salesStaffId: null,
                // 预约到访
                receiveStaffId: null,
                // 临时补约
                temporaryStaffId: null,
                status: null,
                date: null,
                storeId: null,
            },
            // 用户信息
            visitorData: [],
            // 预约状态
            status: [],
            // 预约查询
            appointmentData: [],
            stores: [],
            // 选择行
            currentRow: null,
            // 所有接待人
            receptionist: [],
            // 临时补约查询接待人
            temporaryText: null,
            // 预约查询接待人
            appointText: null,
            // 预约到访
            confirmText: null,
            loading: false,
        };
    },
    created() {
        this.handleReset();
        this.fetchStore();
    },
    // 接待人
    computed: {
        filterTemporaryList() {
            if (!this.temporaryText) return this.receptionist;
            const arr = this.receptionist.filter(item =>
                item.nickname.toLowerCase().indexOf(this.temporaryText.toLowerCase()) > -1);
            return arr.length ? arr : [{id: 'no', nickname: this.$t('Common.data_not_found')}];
        },
        filterAppointList() {
            const item = [{
                id: null,
                nickname: this.$t('Common.all_saler'),
            }];
            if (!this.appointText) return item.concat(this.receptionist);
            const arr = this.receptionist.filter(item =>
                item.nickname.toLowerCase().indexOf(this.appointText.toLowerCase()) > -1);
            return arr.length ? arr : [{id: 'no', nickname: this.$t('Common.data_not_found')}];
        },
        filterConfirmList() {
            if (!this.confirmText) return this.receptionist;
            const arr = this.receptionist.filter(item =>
                item.nickname.toLowerCase().indexOf(this.confirmText.toLowerCase()) > -1);
            return arr.length ? arr : [{id: 'no', nickname: this.$t('Common.data_not_found')}];
        },
    },
    methods: {
        handleReset() {
            this.form = {
                keyword: '',
                salesStaffId: null,
                receiveStaffId: null,
                temporaryStaffId: null,
                status: null,
                date: null,
                storeId: null,
            };
            this.visitorData = [];
            this.status = [];
            this.appointmentData = [];
            this.stores = [];
            this.currentRow = null;
            this.receptionist = [];
            this.temporaryText = null;
            this.appointText = null;
            this.confirmText = null;
        },
        handleCurrentChange(val) {
            this.currentRow = val;
        },
        filterTime() {
            const date = new Date();
            const year = date.getFullYear();
            let month = date.getMonth() + 1;
            let day = date.getDate();
            if (month < 10) month = `0${month}`;
            if (day < 10) day = `0${day}`;
            return `${year}-${month}-${day}`;
        },
        // 门店
        async fetchStore() {
            await API.get('store/list').then(res => {
                this.stores = res;
                this.form.storeId = res[0].id;
            });
            this.fetchStatus();
            this.fetchReceptionist();
        },
        async fetchStatus() {
            await API.get('constant/reception').then(res => {
                this.status = res.appointmentStatus;
            });
            this.fetchData();
        },
        async fetchReceptionist() {
            const ids = [5, 6];
            this.receptionist = await this.filterRole(null, ids);
            this.form.receiveStaffId = this.receptionist[0].id;
            this.form.temporaryStaffId = this.receptionist[0].id;
        },
        // 搜索
        async searchAppoint(val) {
            if (val) this.form.keyword = val;
            this.loading = true;
            await API.get('reception/client', {
                params: {
                    keyword: this.form.keyword,
                },
            }).then(res => {
                this.visitorData = [];
                if (res.clientId) this.visitorData.push(res);
                // 没有该客户，新建
                else this.$refs.newCustomer.open();
            });
            this.fetchData();
        },
        fetchData() {
            this.loading = true;
            if (!this.form.date) this.form.date = this.filterTime();
            const form = {
                date: this.form.date,
                keyword: this.form.keyword,
                salesStaffId: this.form.salesStaffId,
                status: this.form.status,
            };
            API.get('reception/appointment', {
                params: form,
            }).then(res => {
                this.appointmentData = res;
            }).finally(() => this.loading = false);
        },
        // 临时补约
        handleTemporary() {
            this.loading = true;
            if (!this.visitorData.length) return $ele.$message(this.$t('Reception.Second.tips'));
            const form = {
                clientId: this.visitorData[0].clientId,
                salesStaffId: this.form.temporaryStaffId,
            };
            API.post('reception/temporary-visit', form).then(res => {
                this.fetchData();
                this.form.keyword = null;
                this.visitorData = [];
            });
        },
        // 预约到访
        handleAppoint() {
            if (!this.currentRow) return $ele.$message(this.$t('Common.choose_one'));
            this.loading = true;
            const appointmentId = this.currentRow.id;
            const form = {
                storeId: this.form.storeId,
                receiveStaffId: this.form.receiveStaffId,
            };
            API.put(`reception/client-visit/${appointmentId}`, form).then(() => {
                $ele.$message.success(this.$t('Message.success'));
                this.fetchData();
            });
        },
        // 客户离场
        handleLeave() {
            if (!this.currentRow) return $ele.$message(this.$t('Common.choose_one'));
            this.loading = true;
            const appointmentId = this.currentRow.id;
            API.put(`reception/client-leave/${appointmentId}`).then(() => {
                $ele.$message.success(this.$t('Message.success'));
                this.fetchData();
            });
        },
        // 取消预约
        handleCancel() {
            if (!this.currentRow) return $ele.$message(this.$t('Common.choose_one'));
            this.loading = true;
            const appointmentId = this.currentRow.id;
            API.put(`reception/cancel-appointment/${appointmentId}`).then(() => {
                $ele.$message.success(this.$t('Message.success'));
                this.fetchData();
            });
        },
    },
};
</script>

<style lang="scss">
.visit-registra-table {
    tbody {
        tr.el-table__row {
            cursor: pointer;
        }
    }
}
</style>
